
import { Options, Vue } from "vue-class-component";
import EventGuestHeader from "./components/EventGuestHeader.vue";
import EventGuestImage from "./components/EventGuestImage.vue";
import EventGuestTitleBar from "./components/EventGuestTitleBar.vue";
import TextField from "./components/TextField.vue";
import EventSchedule from "./components/EventSchedule.vue";
import Copyrights from "./components/Copyrights.vue";
import SocialMediaButtons from "./components/SocialMediaButtons.vue";
import Contact from "./components/Contact.vue";
import GuestLinkCards from "./components/GuestLinkCards.vue";
// @ts-ignore
import eventData from "./data/eventData.js";
import { useRoute } from "vue-router";
import { sortedDays } from "./data/functions";
import type { Event as EventType } from "./types/types";

@Options({
  components: {
    EventGuestHeader,
    EventGuestImage,
    EventGuestTitleBar,
    TextField,
    EventSchedule,
    Copyrights,
    SocialMediaButtons,
    Contact,
    GuestLinkCards,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
})
export default class Event extends Vue {
  route = useRoute();
  sortedDays = sortedDays;
  id = this.route.params.id;
  // @ts-ignore
  event: EventType = eventData.filter(
    (event: { id: string }) => event.id === this.id
  )?.[0];
  name: string = this.event.title;
  image: string = this.event.image;
  day: string = this.event.day;
  twitter?: string = this.event.links?.twitter;
  instagram?: string = this.event.links?.instagram;
  facebook?: string = this.event.links?.facebook;
  deezer?: string = this.event.links?.deezer;
  spotify?: string = this.event.links?.spotify;
  soundcloud?: string = this.event.links?.soundcloud;
  youtube?: string = this.event.links?.youtubeChannel;
  telephone?: string = this.event.phone;
  email?: string = this.event.email;
  website?: string = this.event.website;
  copyright?: string = this.event.copyright;
  description?: string = this.event.description;
  country?: string = this.event.origin;
  tags: string[] = this.event.genres;
  place: string = this.event.place;
  guests: object = this.event.guests;
  hour: string = this.event.hour;
}
